import React from "react";
import { ButtonWithLoader } from "@src/components/atoms/buttons/button-with-loader/button-with-loader";
import closeIcon from "@src/assets/svg/close-icon-gray.svg";
import styles from "./ota-confirm-backup-process-modal.module.scss";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import { OTASecondaryButton } from "@src/components/atoms/buttons/ota-secondary-button/ota-secondary-button";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";
import { useOtaConfirmBackupProcessModal } from "./use-ota-confirm-backup-process-modal";

type ConfirmBackupData = ActiveInstallationProcessPayload;

const cssClassName = "ota-confirm-backup-process-modal";

const OTAConfirmBackupProcessModal = ({
  data,
  onClose,
}: {
  data: ConfirmBackupData;
  onClose: () => void;
}) => {
  const {
    texts,
    machine,
    targetPath,
    handleCloseModal,
    handleApprove,
    isApproveLoading,
  } = useOtaConfirmBackupProcessModal(data, onClose);

  return (
    <div className={styles[cssClassName]}>
      <div
        className={styles[`${cssClassName}__overlay`]}
        aria-label={texts.closeModalAriaLabel}
      />
      <div className={styles[`${cssClassName}__dialog-wrapper`]}>
        <div
          className={styles[`${cssClassName}__modal-body`]}
          role="dialog"
          aria-modal="true"
        >
          <div className={styles[`${cssClassName}__header`]}>
            <h2 className={styles[`${cssClassName}__title`]}>{texts.title}</h2>
            <IconButton
              fun={handleCloseModal}
              icon={closeIcon}
              tooltipPosition="top"
              variant="close-button"
              disabled={isApproveLoading}
            />
          </div>

          <div className={styles[`${cssClassName}__form`]}>
            <FlexColumnContainer verticalGap={20} alignItems="stretch">
              <FlexColumnContainer verticalGap={15} alignItems="stretch">
                <p className={styles[`${cssClassName}__section-title`]}>
                  {texts.targetPathLabel}
                </p>
                <div className={styles[`${cssClassName}__info-card`]}>
                  <p className={styles[`${cssClassName}__path-text`]}>
                    {targetPath}
                  </p>
                </div>
              </FlexColumnContainer>

              <FlexColumnContainer verticalGap={15} alignItems="stretch">
                <p className={styles[`${cssClassName}__section-title`]}>
                  {texts.sourceMachineLabel}
                </p>
                <div className={styles[`${cssClassName}__info-card`]}>
                  <p className={styles[`${cssClassName}__machine-name`]}>
                    {machine.name}{" "}
                    {machine.ip && (
                      <span className={styles[`${cssClassName}__machine-ip`]}>
                        ({machine.ip})
                      </span>
                    )}
                  </p>
                </div>
              </FlexColumnContainer>

              <p className={styles[`${cssClassName}__warning-text`]}>
                {texts.warningText}
              </p>
            </FlexColumnContainer>
          </div>

          <div className={styles[`${cssClassName}__buttons-wrapper`]}>
            <OTASecondaryButton
              fun={handleCloseModal}
              text={texts.cancelButtonText}
              disabled={isApproveLoading}
            />
            <ButtonWithLoader
              fun={handleApprove}
              text={texts.approveButtonText}
              loading={isApproveLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTAConfirmBackupProcessModal;
